// extracted by mini-css-extract-plugin
export default {"container":"styles__container___tgSA9","label":"styles__label___vtAVq","separator":"styles__separator___YgxlR","sort":"styles__sort___EeDec"};